import styles from './UserSearch.module.css';
import { useEffect } from 'react';
import { Button, CircularProgress, Tooltip, Typography } from '@material-ui/core';
import { Autocomplete, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const UserSearch = ({ shop, putShop, getAllUsers, handleRefresh, allUsers, maintainers }) => {
  const [selectedUser, setSelectedUser] = useState();
  const [inputValue, setInputValue] = useState();
  const { t } = useTranslation();

  const [loading, setLoading] = useState();

  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);

  const user = useSelector((state) => state.nonPersistedReducers.userSliceReducer.currentUser);

  const handleAdd = async () => {
    setLoading(true);
    await putShop({
      body: {
        ...shop,
        maintainers: [...shop.maintainers, { scopes: [], user: { ...selectedUser } }]
      }
    });
    setSelectedUser(null);
    setLoading(false);
    handleRefresh();
  };

  useEffect(() => {
    getAllUsers({ maintainers: maintainers, shopOwner: shop?.owner });
  }, [maintainers]);
  return (
    <>
      <Typography className={styles.searchTitle}>{t('roles.userSearch.title')}</Typography>
      <div className={styles.searchField}>
        {allUsers && (
          <Autocomplete
            // disabled={!groups || groups?.length === 0}
            disablePortal
            disableClearable
            id='user-autocomplete'
            options={allUsers && allUsers?.filter((user) => user?.username === inputValue)}
            getOptionLabel={(option) => option?.username || ''}
            sx={{ width: 300, fontFamily: 'var(--font-main)' }}
            value={selectedUser || ''}
            className={styles.autocomplete}
            onChange={(event, selectedUser) => {
              setSelectedUser(selectedUser);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  style: { fontFamily: 'var(--font-main)' }
                }}
                onChange={(e) => setInputValue(e.target.value)}
                label={t('roles.userSearch.search')}
              />
            )}
          />
        )}
        {user?.ownedShops[0]?.id !== shopId &&
        !user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.scopes?.includes('MANAGE_SHOP') ? (
          <Tooltip title={t('roles.userSearch.tooltip')}>
            <Button className={styles.disabledAddButton}>
              <AddIcon />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title={t('roles.userSearch.addShop')}>
            <Button className={styles.addButton} disabled={!selectedUser || loading} onClick={handleAdd}>
              {loading ? <CircularProgress style={{ color: 'whitesmoke' }} /> : <AddIcon />}
            </Button>
          </Tooltip>
        )}
      </div>
    </>
  );
};

export default UserSearch;
